export default "__VITE_ASSET__ePkwYZgQ__"